module.exports = __webpack_public_path__ + "img/Tutorial_InstallAsApp.a7da787a.jpg";